import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import UserLogin from "@/pages/UserLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminDeposits from "@/pages/admin/AdminDeposits";
import AdminWithdrawals from "@/pages/admin/AdminWithdrawals";
import AdminTransactions from "@/pages/admin/AdminTransactions";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminDisputes from "@/pages/admin/AdminDisputes";
import UserDisputes from "@/pages/user/UserDisputes";
import UserLayout from "@/pages/user/UserLayout";
import UserDashboard from "@/pages/user/UserDashboard";
import UserDeposit from "@/pages/user/UserDeposit";
import UserWithdraw from "@/pages/user/UserWithdraw";
import UserHistory from "@/pages/user/UserHistory";

function Splash() {
  return (
    <div className="min-h-screen grid place-items-center bg-[#090D14]">
      <Loader2 className="h-9 w-9 animate-spin text-emerald-400" />
    </div>
  );
}

function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/login"} replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (role === "user" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/login" element={<UserLogin />} />

      <Route path="/admin" element={<Protected role="admin"><AdminLayout /></Protected>}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="deposits" element={<AdminDeposits />} />
        <Route path="withdrawals" element={<AdminWithdrawals />} />
        <Route path="transactions" element={<AdminTransactions />} />
        <Route path="activity" element={<AdminActivity />} />
        <Route path="disputes" element={<AdminDisputes />} />
      </Route>

      <Route path="/dashboard" element={<Protected role="user"><UserLayout /></Protected>}>
        <Route index element={<UserDashboard />} />
        <Route path="deposit" element={<UserDeposit />} />
        <Route path="withdraw" element={<UserWithdraw />} />
        <Route path="history" element={<UserHistory />} />
        <Route path="disputes" element={<UserDisputes />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}
